export default function RequestPayment() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7494 16.25H18.7494M11.2494 16.25H12.7494M2.24939 9.5799H21.7494M2.99994 5.75H20.9999C21.4142 5.75 21.7499 6.08579 21.7499 6.5V18.5C21.7499 18.9142 21.4142 19.25 20.9999 19.25H2.99994C2.58573 19.25 2.24994 18.9142 2.24994 18.5V6.5C2.24994 6.08579 2.58573 5.75 2.99994 5.75Z"
        stroke="#B721FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="14" y="11" width="11" height="11" rx="5.5" fill="#FBF4FF" />
      <path
        d="M20.25 14.0938C20.25 13.6795 19.9142 13.3438 19.5 13.3438C19.0858 13.3438 18.75 13.6795 18.75 14.0938H19.5H20.25ZM19.5 16.5H18.75C18.75 16.9142 19.0858 17.25 19.5 17.25V16.5ZM21.9062 17.25C22.3205 17.25 22.6562 16.9142 22.6562 16.5C22.6562 16.0858 22.3205 15.75 21.9062 15.75V16.5V17.25ZM23.625 16.5H22.875C22.875 18.364 21.364 19.875 19.5 19.875V20.625V21.375C22.1924 21.375 24.375 19.1924 24.375 16.5H23.625ZM19.5 20.625V19.875C17.636 19.875 16.125 18.364 16.125 16.5H15.375H14.625C14.625 19.1924 16.8076 21.375 19.5 21.375V20.625ZM15.375 16.5H16.125C16.125 14.636 17.636 13.125 19.5 13.125V12.375V11.625C16.8076 11.625 14.625 13.8076 14.625 16.5H15.375ZM19.5 12.375V13.125C21.364 13.125 22.875 14.636 22.875 16.5H23.625H24.375C24.375 13.8076 22.1924 11.625 19.5 11.625V12.375ZM19.5 14.0938H18.75V16.5H19.5H20.25V14.0938H19.5ZM19.5 16.5V17.25H21.9062V16.5V15.75H19.5V16.5Z"
        fill="#B721FF"
      />
    </svg>
  );
}
